import { buildBloodMoon } from './bloodmoon.ts';
import type { OmenCtx, OmenScene } from './common.ts';
import { buildFog } from './fog.ts';
import { buildFrenzy } from './frenzy.ts';
import { buildFrost } from './frost.ts';
import { buildNight } from './night.ts';
import { buildStarfall } from './starfall.ts';
import { buildStorm } from './storm.ts';
import { buildSwarm } from './swarm.ts';

export type { OmenCtx, OmenScene } from './common.ts';

/** The look of the day's omen (ink has its own layer, engine/ink.ts); null for none. `radius`: of the board, in world units. */
export const buildOmen = (omen: string | undefined, ctx: OmenCtx, radius: number): OmenScene | null => {
  switch (omen) {
    case 'fog':
      return buildFog(ctx);
    case 'frenzy':
      return buildFrenzy(ctx);
    case 'swarm':
      return buildSwarm(ctx);
    case 'storm':
      return buildStorm(ctx);
    case 'frost':
      return buildFrost(ctx, radius);
    case 'bloodMoon':
      return buildBloodMoon(ctx);
    case 'starfall':
      return buildStarfall(ctx);
    // Not a day's omen: Brann's bet «A oscuras» (rules.bet === 'dark').
    case 'night':
      return buildNight(ctx, radius);
    default:
      return null;
  }
};
